import React from 'react';
import styled from 'styled-components';
import { colors } from '../themes';
import { ValidationError } from '@nextinq.public/usable-form/lib/types';

const Container = styled.div<{ severity: string }>`
  color: ${(p) => (p.severity === 'warning' ? colors.status.warn : colors.status.error)};
`;

interface ErrorItemProps {
  error: ValidationError | null | undefined;
}

export function ErrorItem(props: ErrorItemProps) {
  const { error } = props;
  if (!error) {
    return null;
  }
  return (
    <Container severity={error.severity || 'error'}>{props.error && props.error.message}</Container>
  );
}
